import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectObjectSearchState } from '../../../../store/selectors';
import { ObjectSearchState, } from '../../../../store/objectSearch/ObjectSearchState';
import { MessageDialog } from '@sas/nova-commons/components/MessageDialog';
import { useI18n } from '../../../../locale/I18nContext';
export const DiscardChangesDialogBase = (props) => {
    var _a;
    const localize = useI18n();
    const featurePendingRedraw = props.featurePendingRedraw !== undefined && props.featurePendingRedraw.index >= 0
        ? (_a = props.features) === null || _a === void 0 ? void 0 : _a[props.featurePendingRedraw.index]
        : undefined;
    return (React.createElement(MessageDialog, { type: "warning", isOpen: featurePendingRedraw !== undefined, title: localize({
            key: (featurePendingRedraw === null || featurePendingRedraw === void 0 ? void 0 : featurePendingRedraw.type) === 'area'
                ? 'DiscardChangesDialog.title.area.txt'
                : 'DiscardChangesDialog.title.route.txt',
        }), text: localize({
            key: (featurePendingRedraw === null || featurePendingRedraw === void 0 ? void 0 : featurePendingRedraw.type) === 'area'
                ? 'DiscardChangesDialog.text.area.txt'
                : 'DiscardChangesDialog.text.route.txt',
            args: {
                label: (featurePendingRedraw === null || featurePendingRedraw === void 0 ? void 0 : featurePendingRedraw.name) || '',
            },
        }), firstAction: {
            text: localize({ key: 'DiscardChangesDialog.discard.txt' }),
            onPress: () => {
                var _a;
                if (props.featurePendingRedraw !== undefined) {
                    if (!props.featurePendingRedraw.pendingNavSelection) {
                        props.onResetFocus();
                    }
                    else if (props.featurePendingRedraw.pendingNavSelection.length > 0) {
                        const queuedNavSelectionIndex = props.featurePendingRedraw.pendingNavSelection[0].index;
                        // delay any potential queued navigation actions to allow for dialog and panel updates
                        setTimeout(() => {
                            props.actions.notifyUpdateSelection(props.id, {
                                features: [queuedNavSelectionIndex],
                                navigate: true,
                            });
                        }, 0);
                    }
                    if ((featurePendingRedraw === null || featurePendingRedraw === void 0 ? void 0 : featurePendingRedraw.type) === 'area') {
                        props.actions.notifyClearArea(props.id, {
                            index: props.featurePendingRedraw.index,
                            revertChanges: true,
                        });
                    }
                    else if ((featurePendingRedraw === null || featurePendingRedraw === void 0 ? void 0 : featurePendingRedraw.type) === 'route') {
                        props.actions.notifyClearRoute(props.id, {
                            index: props.featurePendingRedraw.index,
                            revertChanges: true,
                        });
                    }
                    props.actions.update(props.id, Object.assign({ featurePendingRedraw: undefined }, (((_a = props.featurePendingRedraw.pendingNavSelection) === null || _a === void 0 ? void 0 : _a.length) === 0 && {
                        navSelection: [],
                    })));
                }
            },
        }, secondAction: {
            text: localize({
                key: 'DiscardChangesDialog.cancel.txt',
            }),
            onPress: () => {
                if (props.featurePendingRedraw !== undefined) {
                    // make sure to restore a potential lost selection (eg if dialog was triggered by a map feature selection change event)
                    props.actions.notifyUpdateSelection(props.id, {
                        features: [props.featurePendingRedraw.index],
                    });
                }
                props.actions.update(props.id, {
                    featurePendingRedraw: undefined,
                });
            },
            isDefault: true,
        } }));
};
export const DiscardChangesDialog = connect((state, props) => {
    var _a;
    const { features, featurePendingRedraw } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    return { features, featurePendingRedraw };
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(DiscardChangesDialogBase);
